import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './Dryer.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import LocationReviewsData from './LocationReviewsData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img22 from '../../Images/dryercleaned.jpg'
import img23 from '../../Images/dryercleaning.jpg'

export default function Dryer({ CitiePhone, locationsMain, CitiesData }) {

    const [Service, setService] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE AttiAir?",
                "content": "AttiAir stands out with years of experience and a dedication to safety and quality. Our professional team uses advanced equipment to thoroughly clean your Dryer Vents, helping protect your home from fire hazards and improving dryer efficiency. We pride ourselves on reliable service and complete customer satisfaction."
            },
            {
                "title": "WHAT SERVICES DO YOU OFFER?",
                "content": "We offer a full range of Dryer Vent services, including residential and commercial Dryer Vent cleaning, Dryer Vent repairs, inspections, and routine maintenance. Our goal is to keep your dryer running safely and efficiently while protecting your home."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our Dryer Vent cleaning starts at just $99, and Dryer Vent repair services start at $79. We also provide free consultations to assess your system and recommend the best solutions with transparent pricing."
            },
            {
                "title": "CAN YOU CLEAN AND REPAIR AT THE SAME TIME?",
                "content": "Absolutely! AttiAir specializes in same-day Dryer Vent cleaning and repair. If we discover any issues during your service, we can fix them on the spot to save you time and restore your dryer's safety and performance."
            },
            {
                "title": `DO YOU PROVIDE SERVICES IN ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Yes, we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and the surrounding regions. Our service covers a 75-mile radius, ensuring that nearby homes and businesses can benefit from our top-rated Dryer Vent services.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking with AttiAir is easy! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out our <a href='#book'>online booking form</a>. We'll confirm your appointment and take care of the rest.`
            },
            {
                "title": "HOW OFTEN SHOULD DRYER VENTS BE CLEANED?",
                "content": "Dryer Vents should be cleaned at least once a year to prevent lint buildup, reduce fire risks, and keep your dryer operating efficiently. Homes with frequent dryer use may need cleaning more often."
            },
            {
                "title": "WHY IS DRYER VENT CLEANING IMPORTANT?",
                "content": "Dryer Vent cleaning is essential to prevent dangerous lint buildup, reduce fire hazards, and keep your dryer working at its best. Regular cleaning can also lower energy costs and extend the life of your dryer."
            }
        ]
    };

    const styles = {
        bgColor: '#f3f3f3',
        titleTextColor: '#222222',
        titleTextSize: '18px',
        rowTitleColor: '#222222',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AttiAir from title)(if no keywords just do for Dryer Vent) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="Dryer" id="homepage">
   <Helmet>
    {/* <!-- TITLE (Max 65 characters) --> */}
    <title>AttiAir - Dryer Vent Cleaning & Repair | Fire Prevention Experts | 866-257-5796</title>

    {/* <!-- META TITLE (Max 35 characters) --> */}
    <meta name="title" property="title" content="AttiAir - Dryer Vent Cleaning & Repair | Fire Prevention Experts | 866-257-5796" data-react-helmet="true" />
    <meta name="og:title" property="og:title" content="AttiAir - Dryer Vent Cleaning & Repair | Fire Prevention Experts | 866-257-5796" data-react-helmet="true" />

    {/* <!-- META DETAILS --> */}
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.attiair.com/images/dryervent-og.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content="https://www.attiair.com/dryer-vent-cleaning" data-react-helmet="true" />

    {/* <!-- META DESCRIPTION (Max 155 characters, First Letter Uppercase) --> */}
    <meta 
        name="description" 
        content="AttiAir Offers Expert Dryer Vent Cleaning And Repair Services To Improve Efficiency, Prevent Fires, And Extend The Life Of Your Appliance." 
        data-react-helmet="true" 
    />
    <meta 
        name="og:description" 
        property="og:description" 
        content="AttiAir Offers Expert Dryer Vent Cleaning And Repair Services To Improve Efficiency, Prevent Fires, And Extend The Life Of Your Appliance." 
        data-react-helmet="true" 
    />

    <meta name="og:site_name" property="og:site_name" content="AttiAir" data-react-helmet="true" />

    {/* <!-- KEYWORDS --> */}
    <meta 
        name="keywords" 
        content="Dryer Vent Cleaning, Dryer Vent Repair, Dryer Line Cleaning, Lint Removal, Fire Prevention, Dryer Exhaust Cleaning, Ventilation Services, Home Safety, Energy Efficiency, Dryer Maintenance, Same Day Dryer Cleaning, Improve Dryer Performance, Prevent Dryer Fires, Appliance Efficiency, Dryer Vent Services Near Me" 
        data-react-helmet="true" 
    />
</Helmet>

            {/* DryerMainBanner */}
            <div className="DryerMainBanner" >
                <div className="DryerMainBannerTopLine">
                    <div className="DryerMainBannerTopLineLine"></div>
                    <div className="DryerMainBannerTopLineDot"></div>
                    <h1>DRYER VENT SERVICES</h1>
                </div>
                <div className="DryerMainBannerTop">
                    <img src={require(`../../Images/dryerrepair.jpg`)} />
                    <img src={require(`../../ImagesLogos/Logo1.png`)} className="bannerlogohere" />
                    <div className="DryerMainBannerTopLEFT"></div>

                </div>
                <div className="DryerMainBannerBottom">
                    <div className="DryerMainBannerBottomLeft">
                        <h1>The Dryer Vent Experts You've Trusted for Over 20 Years In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Dryer Vent Cleaning and Repair Near Me</h2>
                        <div className="DryerMainBannerBottomLeftBtns">
                            <a target='_blank' href={`tel:${CitiePhone}`}>Call Us Now</a>
                            <a target='_blank' href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>


                        <h4>DRYER VENT CLEANING {CitiesData.City ? CitiesData.City.toUpperCase() : "| LOCAL SERVICE"}</h4>
                        <div className="DryerMainBannerBottomLeftLine"></div>
                        <p>Fresh air starts with clean dryer vents. Over time, lint, debris, and even mold can build up inside your dryer vent, restricting airflow and creating a serious fire hazard. Professional dryer vent cleaning clears out these blockages, improves your dryer's performance, reduces energy use, and helps keep your home safe. A cleaner vent means faster drying times, lower utility bills, and peace of mind for you and your family.</p>
                        <p>Breathe easier with a clean dryer vent. Hidden lint and clogs not only affect your dryer's efficiency but can also impact your indoor air quality. Removing these obstructions helps protect your home from potential fires, reduces allergens, and extends the life of your appliance. Invest in dryer vent cleaning and enjoy a safer, healthier, and more efficient home.</p>
                        <div className="MainBannerLeftRatedMain">

                            <div className="Header2Location">
                                <img src={require(`../../Images/place.png`)} alt="" />
                                <h6>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h6>

                            </div>
                            <div className="MainBannerLeftRated">
                                <h3>Rated 4.9 on Google</h3>
                                <span>
                                    <h4>4.9</h4>
                                    <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="DryerMainBannerBottomRight">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                        <img src={require(`../../Images/banner55.jpeg`)} />
                        <h3><img src={require(`../../Images/stars.png`)} alt="Locally Owned & Operated AttiAir Chimney Sweep Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Licensed | Bonded | Insured AttiAir Chimney Sweep Repair" />Certified | Licensed | Insured</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Satisfaction Guaranteed AttiAir Chimney Sweep Repair" />Satisfaction Guaranteed</h3>

                    </div>
                </div>
            </div>
            {/* DryerMainBannerService */}
            <div className="DryerMainBannerService">
                <div className="DryerMainBannerServiceMenu">
                    <div className="DryerMainBannerServiceMenuBox" style={Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => true)}>
                        <h1>Dryer Vent</h1>
                    </div>
                    <div className="DryerMainBannerServiceMenuBox" style={!Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "border-top": "8px solid #fcb116" }} onClick={() => setService(a => false)}>
                        <h1>Air Duct</h1>
                    </div>
                </div>
                {Service ?

                    <div className="DryerMainBannerServiceInfo">
                        <div className="DryerMainBannerServiceInfoTop">
                            <div className="DryerMainBannerServiceInfoLeft">
                                <h1>DRYER VENT SERVICE</h1>
                                <img src={require(`../../Images/Before5.jpeg`)} />
                            </div>
                            <div className="DryerMainBannerServiceInfoRight">
                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Lint Buildup" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>Clothes Taking Too Long to Dry?</h2>
                                        <h3>Are your clothes still damp after a full cycle? A clogged Dryer Vent restricts airflow, making your dryer work harder and less efficiently. Our professional cleaning restores performance and saves you time.</h3>
                                    </div>
                                </div>

                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Fire Hazard" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>Concerned About Fire Risks?</h2>
                                        <h3>Lint buildup in your Dryer Vent is a leading cause of house fires. If your dryer feels excessively hot or you notice a burning smell, it’s time for a professional cleaning to protect your home and family.</h3>
                                    </div>
                                </div>

                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Efficiency Issues" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>High Energy Bills?</h2>
                                        <h3>A clogged Dryer Vent forces your dryer to work harder, increasing energy consumption and raising your utility bills. Cleaning your vent improves efficiency and helps you save money.</h3>
                                    </div>
                                </div>

                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Mold & Musty Smell" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>Musty Smell in Your Laundry Room?</h2>
                                        <h3>Excess moisture from a clogged Dryer Vent can lead to mold growth and unpleasant odors. Regular vent cleaning prevents mold buildup and keeps your laundry room fresh.</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR DRYER SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/aircleaning.png`)} alt="Dryer Vent Cleaning" />
                                            <h3>Dryer Vent Cleaning</h3>
                                            <h4>Improve Dryer Performance & Safety</h4>
                                            <h2>Remove lint buildup to improve efficiency, prevent fire hazards, and extend the lifespan of your dryer.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airdryer.png`)} alt="Dryer Vent Inspection" />
                                            <h3>Dryer Vent Inspection</h3>
                                            <h4>Detect Issues Before They Get Worse</h4>
                                            <h2>Ensure your vent system is free from blockages, damage, or lint buildup with a thorough professional inspection.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airinspection.png`)} alt="Dryer Vent Maintenance" />
                                            <h3>Dryer Vent Maintenance</h3>
                                            <h4>Keep Your Dryer Running Efficiently</h4>
                                            <h2>Routine maintenance prevents airflow restrictions, reduces energy use, and helps prevent costly repairs.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airrepair.png`)} alt="Dryer Vent Repair" />
                                            <h3>Dryer Vent Repair</h3>
                                            <h4>Fix Damage & Ensure Proper Ventilation</h4>
                                            <h2>Repair or replace damaged or disconnected vents to improve airflow and maintain dryer safety.</h2>
                                        </a>
                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="DryerMainBannerServiceInfo">
                        <div className="DryerMainBannerServiceInfoTop">
                            <div className="DryerMainBannerServiceInfoLeft">
                                <h1>AIR DUCT SERVICE</h1>
                                <img src={require(`../../Images/banner56.jpeg`)} />
                            </div>
                            <div className="DryerMainBannerServiceInfoRight">
                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Dust Problem" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>Dust Building Up Too Fast?</h2>
                                        <h3>Constantly dusting but it never seems to go away? Your Air Ducts might be the culprit, spreading dust throughout your home. Our expert duct cleaning service can help keep your home fresher and dust-free.</h3>
                                    </div>
                                </div>

                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Allergy Relief" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>Struggling with Allergies or Asthma?</h2>
                                        <h3>Indoor air pollutants like dust, pet dander, and mold can worsen allergies and asthma. Our Air Duct cleaning service removes these contaminants, helping you and your family breathe easier.</h3>
                                    </div>
                                </div>

                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Mold Issues" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>Concerned About Mold?</h2>
                                        <h3>Mold growth in or around your Air Ducts is a serious health risk. Spores can spread through your ventilation system, affecting the air you breathe. Our mold removal and duct cleaning service ensures a safer, healthier home.</h3>
                                    </div>
                                </div>

                                <div className="DryerBenefitsBox">
                                    <div className="DryerBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Energy Savings" />
                                    </div>
                                    <div className="DryerBenefitsBoxBox">
                                        <h2>High Energy Bills?</h2>
                                        <h3>If your HVAC system is working harder than it should, dirty Air Ducts could be the reason. Blocked airflow forces your system to use more energy, driving up costs. Our duct cleaning service boosts efficiency and saves you money.</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR AIR DUCT SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/aircleaning.png`)} alt="Air Duct Cleaning" />
                                            <h3>Air Duct Cleaning</h3>
                                            <h4>Improve Air Quality & HVAC Efficiency</h4>
                                            <h2>Eliminate dust, allergens, and contaminants from your ductwork for cleaner air, reduced allergens, and a healthier home.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airdryer.png`)} alt="Air Duct Inspection" />
                                            <h3>Air Duct Inspection</h3>
                                            <h4>Detect Issues Before They Get Worse</h4>
                                            <h2>Ensure your ductwork is free from blockages, leaks, and mold with a professional inspection to maintain optimal airflow.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airinspection.png`)} alt="Air Duct Maintenance" />
                                            <h3>Air Duct Maintenance</h3>
                                            <h4>Extend the Life of Your HVAC System</h4>
                                            <h2>Routine maintenance helps keep your ducts clean, prevents buildup, and improves HVAC performance for energy savings.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airrepair.png`)} alt="Air Duct Repair" />
                                            <h3>Air Duct Repair</h3>
                                            <h4>Fix Leaks & Restore Airflow</h4>
                                            <h2>Repair damaged or leaky ducts to prevent energy loss, improve airflow, and enhance indoor air quality for a healthier home.</h2>
                                        </a>
                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <h4>TAKE THE FIRST STEP TOWARD A HEALTHIER AND MORE <span>EFFICIENT HOME</span><br /> SCHEDULE YOUR Air Duct CLEANING TODAY!</h4>
                <div className="DryerBenefitsbutn">
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                </div>
            </div>

            {/* DryerGoodBY */}
            <div className="DryerGoodBY">
                <h1>SAY GOODBYE TO DIRT AND DUST IN YOUR DRYER VENTS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience cleaner, healthier air with our professional Dryer Vent cleaning services.</h2>
                <div className="DryerGoodBYList">
                    <img src={require(`../../Images/dryercleaned.jpg`)} />
                    <img src={require(`../../Images/dryercleaning.jpg`)} />
                    <img src={require(`../../Images/dryercleaned2.jpg`)} />
                    <img src={require(`../../Images/dryercleaned3.jpg`)} />
                </div>
            </div>
            {/* Dryerbefore */}
            <div className="DryerBefore">
                <div className="DryerBeforeLeft">
                    <h1>THE IMPORTANCE OF CLEAN DRYER VENTS</h1>
                    <h2>Breathe Cleaner, Save Energy, and Protect Your Home</h2>
                    <h3>Your Dryer Vents and Dryer Vents play a vital role in maintaining indoor air quality and home efficiency. Over time, dust, allergens, pet dander, and mold build up in your Dryer Vents, circulating throughout your home and affecting your health. Similarly, clogged Dryer Vents restrict airflow, making your dryer work harder and increasing the risk of fire hazards. Regular Dryer Vent and Dryer Vent cleaning ensures fresh, breathable air, improves HVAC performance, and enhances the safety of your home.</h3>
                    <h2>Why Dryer Vent Cleaning Matters</h2>
                    <h3>
                        ✔ <b>Healthier Air</b> – Eliminate dust, allergens, and pollutants to improve indoor air quality.
                        <br />
                        ✔ <b>Increased HVAC Efficiency</b> – Clean ducts help your system run smoothly, lowering energy costs.
                        <br />
                        ✔ <b>Less Dust in Your Home</b> – Reduce the amount of dust settling on furniture and surfaces.
                        <br />
                        ✔ <b>Extended HVAC Lifespan</b> – Prevent excessive strain on your heating and cooling system.
                    </h3>
                    <h4>Booking with AttiAir is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="DryerBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* DryerReviews */}
            <div className="DryerReviews">
                <div className="DryerReviewsHeader">
                    <h2>Dryer Vent Cleaning Reviews:</h2>
                    <h1>Customers are breathing the difference</h1>
                    <div className="DryerReviewsHeaderLine"></div>
                </div>
                <div className="DryerReviewsMenu">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="DryerReviewsMenuBox">
                            <div className="DryerReviewsMenuBoxStars">
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                            </div>
                            <h1>{A.review}</h1>
                            <h2>{A.customer}</h2>
                        </div>
                    )}
                </div>
            </div>
            {/* DryerBook */}
            <div className="DryerBook" id="book">
                <div className="DryerReviewsHeader">
                    <h2>Easy & Convenient Booking:</h2>
                    <h1>Schedule Your Service Online!</h1>
                    <div className="DryerReviewsHeaderLine"></div>
                </div>
                <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            </div>
            {/* MainBanner2Top2 */}
            <div className="DryerServices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <h3>DRYER VENT CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/dryercleaned.jpg`)} alt="Dryer Vent Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Protect your home from fire hazards and improve efficiency with AttiAir’s expert Dryer Vent cleaning. Over time, lint and debris build up, restricting airflow and increasing safety risks. Our thorough cleaning service removes blockages, restores proper airflow, and helps your dryer run smoothly. Stay safe and save energy—schedule your Dryer Vent cleaning today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Comprehensive Lint Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Blockage Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Dryer Performance Boost</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>DRYER VENT REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/dryerrepair.jpg`)} alt="Dryer Vent Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Damaged or disconnected Dryer Vents can lead to poor airflow, longer drying times, and increased energy bills. AttiAir’s Dryer Vent repair services restore your system for maximum safety and performance. We replace damaged sections, seal leaks, and ensure your venting system works flawlessly. Prevent issues before they start—book your repair today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Leak Sealing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Airflow Restoration</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy Efficiency Improvement</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>DRYER VENT SANITIZATION</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/dryerinspection.jpg`)} alt="Dryer Vent Sanitization" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Ensure your Dryer Vent is not only clean but also sanitized. AttiAir’s sanitization services help eliminate bacteria, mold, and other contaminants from your vent system. Perfect for those concerned about indoor air quality and safety, our treatments provide extra protection for your home. Keep your vents fresh and hygienic—contact us today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Bacteria & Mold Elimination</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Odor Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Sanitizing Treatments</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Enhanced Vent Hygiene</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>AIR DUCT CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/banner56.jpeg`)} alt="Air Duct Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Breathe cleaner, healthier air with AttiAir’s professional Air Duct cleaning services. Over time, dust, allergens, and debris collect in your ductwork, circulating throughout your home. Our advanced cleaning process removes these contaminants, improves airflow, and boosts your indoor air quality. Create a fresher living space today with AttiAir!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Dust & Debris Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Allergen Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Airflow Optimization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Indoor Air Quality</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/Chimney6.jpeg`)} alt="Chimney Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Protect your home with AttiAir’s professional chimney cleaning. We remove dangerous creosote buildup, soot, and debris to reduce fire risks and improve your chimney's performance. Regular cleaning ensures proper airflow and a safer, more efficient fireplace. By maintaining a clean chimney, you can prevent hazardous blockages and ensure smooth, consistent operation of your fireplace. Regular chimney cleaning also helps extend the lifespan of your chimney and prevents costly repairs due to neglected maintenance.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Creosote & Soot Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Blockage Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Draft & Ventilation</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimneyrepair.jpg`)} alt="Chimney Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Damaged chimneys can lead to leaks, structural issues, and safety hazards. AttiAir’s chimney repair services fix cracks, bricks, mortar joints, and flashing to restore your chimney’s safety, performance, and appearance. We specialize in addressing issues that could lead to expensive repairs if left unchecked, such as water damage, crumbling masonry, and improper flashing. With our repair services, your chimney will remain structurally sound, safe, and efficient for years to come.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Brick & Mortar Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Water Leak Sealing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Crown & Flashing Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Structural Restoration</h2>
                            </div>
                        </div>
                    </a>

                </div>

            </div>

            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At AttiAir, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality Dryer Vent cleaning services over {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring healthier and more comfortable living environments. In addition to Dryer Vent cleaning, we also offer a range of services tailored to improve indoor air quality and meet the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me AttiAir" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

